import { ProjectType } from './projectTypes'

const sharedRules = (teamName: string) =>
  `By uploading your video content, you are granting ${teamName} and its affiliates royalty-free, irrevocable, non-exclusive rights and license to re-use this content.\n\nWe encourage creativity, but please ensure that your content respects ethical standards and does not contain any form of inappropriate material. Your commitment to these guidelines ensures an inclusive environment for all our community. Thank you.`

const sharedTips =
  '- Let your personality shine\n- Prop up your phone for a stable shot\n- If filming a scene, experiment with framing to create better visual impact\n- If using a webcam, position yourself in well-lit surroundings for a vibrant and captivating video'

export const getProjectCopyDefaults = (projectType: ProjectType, teamName: string, projectName: string) => {
  const copyByType: Record<ProjectType, { description: string; questions?: string[] }> = {
    video_contribution: {
      description: `Hi ${teamName} community,\n\nSend us your best clip for "${projectName}". Upload an existing video or record one when you are ready.`,
    },
    video_collection: {
      description: `Hi ${teamName} community,\n\nShare the video clips that help tell the story of "${projectName}". You can add several files in one submission.`,
    },
    video_capture: {
      description: `Hi ${teamName} community,\n\nWe would love to hear your response for "${projectName}". When you are ready, record a short video answer.`,
      questions: ['Tell us about your experience'],
    },
    video_conversation: {
      description: `Hi ${teamName} community,\n\nTake part in "${projectName}" by answering each prompt with a short recorded video response.`,
      questions: ['Tell us about your experience', 'What would you like us to know?'],
    },
    video_compliance: {
      description: `Hi ${teamName} team,\n\nCapture the requested visual evidence for "${projectName}" and follow each step shown in the form.`,
    },
  }

  return {
    ...copyByType[projectType],
    rules: sharedRules(teamName),
    tips: sharedTips,
  }
}
